module.exports = __webpack_public_path__ + "img/13n.e0531062.png";